// frontend/packages/business-console/src/pages/Invoices/demoData.js
//
// Handcrafted fixtures for the Invoices list page. Activated via the
// `?demo=1` query string (same sticky-`localStorage["pulse.demo"]`
// mechanism as Pulse + Quotes). Numbers tuned to match the Pulse +
// Quotes fixtures so the cross-page demo reads as a coherent
// SMB field-service tenant doing roughly $25-35k/mo.
//
// Mix is intentional:
//   - 2 paid (recent week)
//   - 1 partial (split payment in flight)
//   - 1 overdue (so the overdue summary chip has a non-zero value)
//   - 1 sent (this morning)
//   - 1 viewed (customer opened it)
//   - 1 draft (operator is still putting it together)
//   - 1 void (history)

export const demoInvoicesList = {
  items: [
    {
      _id: 'demo_invoice_184',
      number: 'INV-0184',
      state: 'paid',
      customerId: 'demo_customer_acme',
      customerName: 'Acme Roofing LLC',
      title: 'Storm damage repair',
      total: 245000,
      amountPaid: 245000,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-12T00:00:00Z',
      createdAt: '2026-05-24T11:30:00Z',
      updatedAt: '2026-05-26T14:22:00Z',
    },
    {
      _id: 'demo_invoice_183',
      number: 'INV-0183',
      state: 'paid',
      customerId: 'demo_customer_kim',
      customerName: 'Sarah Kim',
      title: 'Service call — water heater',
      total: 89500,
      amountPaid: 89500,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-10T00:00:00Z',
      createdAt: '2026-05-23T09:15:00Z',
      updatedAt: '2026-05-26T11:08:00Z',
    },
    {
      _id: 'demo_invoice_182',
      number: 'INV-0182',
      state: 'partial',
      customerId: 'demo_customer_henderson',
      customerName: 'Henderson Group',
      title: 'Annual maintenance — Q2',
      total: 540000,
      amountPaid: 270000,
      amountDue: 270000,
      currency: 'USD',
      dueAt: '2026-06-15T00:00:00Z',
      createdAt: '2026-05-22T13:40:00Z',
      updatedAt: '2026-05-25T16:00:00Z',
    },
    {
      _id: 'demo_invoice_181',
      number: 'INV-0181',
      state: 'paid',
      customerId: 'demo_customer_henderson',
      customerName: 'Henderson Group',
      title: 'Service visit',
      total: 137500,
      amountPaid: 137500,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-09T00:00:00Z',
      createdAt: '2026-05-19T10:00:00Z',
      updatedAt: '2026-05-25T16:45:00Z',
    },
    {
      _id: 'demo_invoice_180',
      number: 'INV-0180',
      state: 'paid',
      customerId: 'demo_customer_wagner',
      customerName: 'Wagner Hospitality',
      title: 'New install — 4 units',
      total: 312000,
      amountPaid: 312000,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-08T00:00:00Z',
      createdAt: '2026-05-18T08:30:00Z',
      updatedAt: '2026-05-25T09:30:00Z',
    },
    {
      _id: 'demo_invoice_179',
      number: 'INV-0179',
      state: 'overdue',
      customerId: 'demo_customer_pinewood',
      customerName: 'Pinewood Estates HOA',
      title: 'Common-area landscaping',
      total: 215000,
      amountPaid: 0,
      amountDue: 215000,
      currency: 'USD',
      dueAt: '2026-05-15T00:00:00Z',
      createdAt: '2026-04-30T11:00:00Z',
      updatedAt: '2026-05-16T03:00:00Z',
    },
    {
      _id: 'demo_invoice_178',
      number: 'INV-0178',
      state: 'viewed',
      customerId: 'demo_customer_santos',
      customerName: 'Maria Santos',
      title: 'Gutter cleaning + soffit repair',
      total: 67500,
      amountPaid: 0,
      amountDue: 67500,
      currency: 'USD',
      dueAt: '2026-06-22T00:00:00Z',
      createdAt: '2026-05-22T16:15:00Z',
      updatedAt: '2026-05-26T08:30:00Z',
    },
    {
      _id: 'demo_invoice_177',
      number: 'INV-0177',
      state: 'sent',
      customerId: 'demo_customer_tilbury',
      customerName: 'Tilbury Construction',
      title: 'Tear-off + new shingle',
      total: 421000,
      amountPaid: 0,
      amountDue: 421000,
      currency: 'USD',
      dueAt: '2026-06-25T00:00:00Z',
      createdAt: '2026-05-26T10:00:00Z',
      updatedAt: '2026-05-26T10:00:00Z',
    },
    {
      _id: 'demo_invoice_176',
      number: 'INV-0176',
      state: 'draft',
      customerId: 'demo_customer_whitfield',
      customerName: 'Jordan Whitfield',
      title: 'Back deck — labor + materials',
      total: 295000,
      amountPaid: 0,
      amountDue: 295000,
      currency: 'USD',
      dueAt: null,
      createdAt: '2026-05-26T14:40:00Z',
      updatedAt: '2026-05-26T14:40:00Z',
    },
    {
      _id: 'demo_invoice_175',
      number: 'INV-0175',
      state: 'void',
      customerId: 'demo_customer_obrien',
      customerName: "Madelyn O'Brien",
      title: 'Deck refinish (voided — quote declined)',
      total: 68000,
      amountPaid: 0,
      amountDue: 0,
      currency: 'USD',
      dueAt: null,
      createdAt: '2026-05-21T10:00:00Z',
      updatedAt: '2026-05-24T17:35:00Z',
    },
  ],
  hasMore: false,
  nextCursor: null,
};
